'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { EDGE_SWIPE_DRAG_PX, EDGE_SWIPE_ZONE_PX, EXIT_INTENT_SIGNAL } from '../../config/exitIntent';
import { isTouchDevice } from '../../lib/isTouchDevice';
import { type ExitIntentTrigger, hasExitIntentBeenShown } from './session';
export function useEdgeSwipeSignal(triggerRef, hasFired) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== hasFired || $[1] !== triggerRef) {
    t0 = () => {
      if (hasFired || hasExitIntentBeenShown() || !isTouchDevice()) {
        return;
      }
      let originX = null;
      let originEdge = null;
      const onTouchStart = event => {
        const touch = event.touches[0];
        if (!touch) {
          return;
        }
        if (touch.clientX <= EDGE_SWIPE_ZONE_PX) {
          originX = touch.clientX;
          originEdge = "left";
        } else {
          if (touch.clientX >= window.innerWidth - EDGE_SWIPE_ZONE_PX) {
            originX = touch.clientX;
            originEdge = "right";
          } else {
            originX = null;
            originEdge = null;
          }
        }
      };
      const onTouchMove = event_0 => {
        if (originX === null || !originEdge) {
          return;
        }
        const touch_0 = event_0.touches[0];
        if (!touch_0) {
          return;
        }
        const deltaX = touch_0.clientX - originX;
        const draggedInward = originEdge === "left" && deltaX >= EDGE_SWIPE_DRAG_PX || originEdge === "right" && deltaX <= -EDGE_SWIPE_DRAG_PX;
        if (draggedInward) {
          triggerRef.current?.(EXIT_INTENT_SIGNAL.mobileEdgeSwipe);
          originX = null;
          originEdge = null;
        }
      };
      const onTouchEnd = () => {
        originX = null;
        originEdge = null;
      };
      window.addEventListener("touchstart", onTouchStart, {
        passive: true
      });
      window.addEventListener("touchmove", onTouchMove, {
        passive: true
      });
      window.addEventListener("touchend", onTouchEnd, {
        passive: true
      });
      return () => {
        window.removeEventListener("touchstart", onTouchStart);
        window.removeEventListener("touchmove", onTouchMove);
        window.removeEventListener("touchend", onTouchEnd);
      };
    };
    t1 = [triggerRef, hasFired];
    $[0] = hasFired;
    $[1] = triggerRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}